const roundedRectPath = (ctx, width, height, radius) => {
  const r = Math.max(0, Math.min(radius || 0, width / 2, height / 2));
  ctx.beginPath();
  if (typeof ctx.roundRect === 'function') {
    ctx.roundRect(0, 0, width, height, r);
  } else {
    ctx.rect(0, 0, width, height);
  }
  ctx.closePath();
};

export const drawBackdropBlur = (ctx, width, height, cornerRadius, blur) => {
  if (!blur || width <= 0 || height <= 0 || !('filter' in ctx)) {
    return;
  }

  const matrix = ctx.getTransform();
  const scale = Math.hypot(matrix.a, matrix.b) || 1;
  const deviceBlur = blur * scale;
  const corners = [
    [0, 0],
    [width, 0],
    [0, height],
    [width, height],
  ].map(([x, y]) => [matrix.a * x + matrix.c * y + matrix.e, matrix.b * x + matrix.d * y + matrix.f]);
  const margin = Math.ceil(deviceBlur * 3);
  const canvas = ctx.canvas;
  const left = Math.max(0, Math.floor(Math.min(...corners.map((p) => p[0]))) - margin);
  const top = Math.max(0, Math.floor(Math.min(...corners.map((p) => p[1]))) - margin);
  const right = Math.min(canvas.width, Math.ceil(Math.max(...corners.map((p) => p[0]))) + margin);
  const bottom = Math.min(canvas.height, Math.ceil(Math.max(...corners.map((p) => p[1]))) + margin);
  if (right <= left || bottom <= top) {
    return;
  }

  ctx.save();
  roundedRectPath(ctx, width, height, cornerRadius);
  ctx.clip();
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.filter = `blur(${deviceBlur}px)`;
  const w = right - left;
  const h = bottom - top;
  ctx.drawImage(canvas, left, top, w, h, left, top, w, h);
  ctx.restore();
};
